/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const VehicleTag = {
    BestValue: 'BEST_VALUE',
    RecommendedForYou: 'RECOMMENDED_FOR_YOU',
    ClosestPickup: 'CLOSEST_PICKUP',
    MostPopular: 'MOST_POPULAR',
    UnlimitedMileage: 'UNLIMITED_MILEAGE',
    BestForGroup: 'BEST_FOR_GROUP'
} as const;
export type VehicleTag = typeof VehicleTag[keyof typeof VehicleTag];


export function instanceOfVehicleTag(value: any): boolean {
    for (const key in VehicleTag) {
        if (Object.prototype.hasOwnProperty.call(VehicleTag, key)) {
            if (VehicleTag[key as keyof typeof VehicleTag] === value) {
                return true;
            }
        }
    }
    return false;
}

export function VehicleTagFromJSON(json: any): VehicleTag {
    return VehicleTagFromJSONTyped(json, false);
}

export function VehicleTagFromJSONTyped(json: any, ignoreDiscriminator: boolean): VehicleTag {
    return json as VehicleTag;
}

export function VehicleTagToJSON(value?: VehicleTag | null): any {
    return value as any;
}

export function VehicleTagToJSONTyped(value: any, ignoreDiscriminator: boolean): VehicleTag {
    return value as VehicleTag;
}

